import {TabsComponent} from './containers/tabs/tabs.component';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {NgModule} from '@angular/core';


const routes: Routes = [{path: '', component: TabsComponent}];

@NgModule({
  declarations: [TabsComponent],
  imports: [CommonModule, RouterModule.forChild(routes), IonicModule, SharedModule]
})

export class TabsModule {
}
